export default "__VITE_ASSET__DbOgYsO3__"